import React from "react";

export const Dlt = (props) => {
  return (
    <div id="privacy" >
      <div className="container">
          <br></br>
          <br></br>
          <br></br>
        <div className="section-title text-center">
          <h2>刪除帳戶與關聯資料說明</h2>
        </div>
        <div className="row">
          <h4>應用程式／開發人員</h4>
          <p>本頁面說明適用於 Google Play 商店中顯示的應用程式 <b>「贏很大娛樂城」 </b>（或由 贏很大娛樂城 開發團隊 發佈的相關應用）。請使用下方步驟提交請求並註明該名稱。
          </p>
          <br></br>
          <h4>如何提出刪除帳戶請求</h4>
          <p>若您希望刪除 <b>「贏很大娛樂城」 </b>帳戶及相關個人資料，請依下列步驟進行：</p>
          <ol>
            <li>1. 寄送電子郵件至：service@yhd.tw</li><br></br>
            <li>2. 在郵件中提供以下資訊以協助我們驗證帳戶所有權：<br></br>
              ●  您的 <b>帳戶名稱／使用者 ID</b>（App 內顯示）<br></br>
              ●  您的 <b>註冊 email 或手機號碼</b><br></br>
              ●  最近一次登入日期或其他可驗證資訊<br></br><br></br>
            </li>
            <li>3. 在郵件中註明您的需求：<b>完全刪除帳戶與所有可刪除個人資料</b></li>
          </ol>
          <p>我們將在收到郵件後<b> 5 個工作日內回覆確認</b>，並於身份驗證完成後開始處理。</p>
          <br></br>
          <h4>將被刪除的資料</h4>
          <p>完成驗證後，我們會刪除以下屬於您的可識別個人資料：</p>
            <ol>
            <li>●  帳戶登入資料（帳號、暱稱、密碼雜湊值）</li>
            <li>●  個人檔案資料（暱稱、頭像、生日、個人設定）</li>
            <li>●  遊戲進度、成就、排行榜資料</li>
            <li>●  偏好設定、推播設定</li>
            <li>●  與客服的非財務性對話紀錄（若法律無另行要求）</li>
          </ol>
          <br></br>
          <h4>可能保留的資料（依法或因安全需求）</h4>
          <p>基於法律與安全需求，下列資料可能無法刪除或需依一定期間保留：</p>
          <ol>
            <li>●  <b>交易紀錄、儲值與帳務資料</b>（依會計／稅務法規，可能需保留最長<b> 7 年</b>）</li>
            <li>●  <b>法務或合規相關資料</b>（若涉及申訴、調查或爭議，將保留至事件結束）</li>
            <li>●  <b>系統備份資料</b>（部分資料可能保留於備份中，並會在 30–90 天內依備份清除周期自動移除）</li>
            <li>●  <b>匿名化資料</b>：可能保留無法識別個人的統計資料，用於內部分析與產品改善</li>
          </ol>
          <br></br>
          <h4>處理時程說明</h4>
          <ol>
            <li>●  收到您的郵件後<b> 5 個工作日內回覆確認</b></li>
            <li>●  完成身份驗證後，一般會在<b> 30 天內</b>完成刪除程序</li>
            <li>●  若資料涉及法律例外或正在處理的爭議案件，我們會主動通知您</li>
          </ol>
          <br></br>
          <h4>若您非帳戶本人</h4>
          <p>如代他人提出刪除請求（如法定代理人），請於郵件中一併提供授權證明文件，以便我們核實與處理。</p>
          <br></br>
          <h4>聯絡方式</h4>
          <p>若您對資料刪除流程有任何疑問，請聯繫：service@yhd.tw</p>
          <br></br>
        </div>
      </div>
    </div>
  );
};
